import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import RateCompare from './RateCompare.js';
import * as hotelActions from './../../../../actions/hotelAction';

const mapStateToProps = state => {
    return {
        hotelState: state.hotelReducer,
        rateState: state.rateReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListRateCompare: (filters) => dispatch(hotelActions.getListRateCompare(filters)),
        getHotelDetail: (id) => dispatch(hotelActions.getHotelDetail(id)),
        deleteRateCompare: (data) => dispatch(hotelActions.deleteRateCompare(data)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(RateCompare));